import React from "react"
import Translation from "components/Translation"

function SupportSettingsModalTitle() {
  return <Translation label="support.title" />
}

export default SupportSettingsModalTitle
